import { useEffect } from 'react';

import { useLatest } from 'hooks/useLatest';

import type { SubmitInterceptor } from './FormContext';
import { useFormContext } from './FormContext';

type Props = {
  onIntercept: SubmitInterceptor;
};

/**
 * Allows performing actions such as updating a value before submitting the form.
 */
export function useFormSubmitInterceptor({ onIntercept }: Props) {
  const { addSubmitInterceptor } = useFormContext();

  const onInterceptRef = useLatest(onIntercept);

  useEffect(
    // Remove when unmounted
    () => addSubmitInterceptor(() => onInterceptRef.current()),
    [addSubmitInterceptor, onInterceptRef],
  );
}

export function FormSubmitInterceptor({ onIntercept }: Props) {
  useFormSubmitInterceptor({ onIntercept });

  return null;
}
